/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { Fragment, type FunctionComponent } from 'react'

import { EuiBadge, EuiFlexItem } from '@elastic/eui'

type Props = {
  items: string[]
  color?: 'default' | 'hollow'
}

const BadgeList: FunctionComponent<Props> = ({ items, color = 'default' }) => (
  <Fragment>
    {items.map((item: string, index: number) => (
      <EuiFlexItem grow={false} key={index}>
        <EuiBadge color={color}>{item}</EuiBadge>
      </EuiFlexItem>
    ))}
  </Fragment>
)

export default BadgeList
